import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useAuthFetch } from "shared/providers/auth/use-auth-fetch";

export const useCancelSubscriptionMutation = () => {
  const fetch = useAuthFetch();
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async () => {
      const response = await fetch(
        `${import.meta.env.VITE_BACKEND_URL}/tribute/cancel`,
        { method: "POST" }
      );
      const data: { success: boolean; message?: string } =
        await response.json();
      return data;
    },
    onSuccess: () => {
      return queryClient.invalidateQueries({
        queryKey: ["api", "tribute", "subscription"],
      });
    },
  });
};
